/**
 * Puts a `.btn` on the static pages into its busy state and back (#387). The
 * markup and its classes are in `button-busy-lib.ts`; the colour rule for a
 * busy button (`.btn[aria-busy="true"]`) is in `styles.css`.
 */
import {
  BUTTON_SPINNER,
  HIDDEN_LABEL_CLASS,
  SPINNER_OVERLAY_CLASS,
  spinnerSvg,
} from "./button-busy-lib";

const LABEL_ATTRIBUTE = "data-busy-label";

export function isButtonBusy(button: HTMLButtonElement): boolean {
  return button.getAttribute("aria-busy") === "true";
}

/**
 * Busy: the label moves into an invisible span and the spinner overlays it.
 * Idle again: the label comes back as it was, and the button is enabled.
 */
export function setButtonBusy(button: HTMLButtonElement, busy: boolean): void {
  if (busy === isButtonBusy(button)) return;

  if (busy) {
    const label = document.createElement("span");
    label.setAttribute(LABEL_ATTRIBUTE, "");
    label.className = HIDDEN_LABEL_CLASS;
    label.append(...Array.from(button.childNodes));

    const overlay = document.createElement("span");
    overlay.className = SPINNER_OVERLAY_CLASS;
    overlay.innerHTML = spinnerSvg(BUTTON_SPINNER);

    button.classList.add("relative");
    button.replaceChildren(label, overlay);
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
  } else {
    const label = button.querySelector(`[${LABEL_ATTRIBUTE}]`);
    button.replaceChildren(...Array.from(label?.childNodes ?? []));
    button.disabled = false;
    button.setAttribute("aria-busy", "false");
  }
}
